module.exports = __webpack_public_path__ + "img/buldozer.9604fce0.png";